import { jsx as o } from "react/jsx-runtime";
import { useMemo as _ } from "react";
import M from "./styles.module.less.js";
import { MobileMenu as f } from "./mobile.js";
import { DesktopMenu as D } from "./desktop.js";
import { DEFAULT_LANGUAGE_CODE as I, canLanguageUseAtticus as h } from "../../../constants.js";
import { useScreenSize as w, WidthType as y } from "../../../utils/use-is-mobile.js";
const k = "FLOATING_CONTAINER_ID", R = "MENU_HEADER_ID", q = (g) => {
  const {
    isAuthenticated: t,
    openAuthModal: r,
    userImage: n,
    logout: i,
    hasNotifications: s,
    language: e = I,
    getTranslation: a,
    isLawyerSupported: u,
    useWill: m,
    lmpEnabled: l,
    onRequestLawyer: c,
    hideLinks: p,
    environment: d,
    lawyerView: A,
    legalHubSupported: E,
    newChatUrl: N
  } = g, L = _(() => h(e) ? e : void 0, [e]);
  return w() === y.Mobile ? /* @__PURE__ */ o("div", { className: M.mobileMenuWrapper, children: /* @__PURE__ */ o(
    f,
    {
      isAuthenticated: t,
      openAuthModal: r,
      userImage: n,
      logout: i,
      hasNotifications: s,
      language: e,
      getTranslation: a,
      isLawyerSupported: u,
      useWill: m,
      lmpEnabled: l,
      onRequestLawyer: L ? c : void 0,
      hideLinks: p,
      environment: d,
      lawyerView: A,
      legalHubSupported: E,
      newChatUrl: N
    }
  ) }) : /* @__PURE__ */ o("div", { className: M.desktopMenuContainer, id: R, children: /* @__PURE__ */ o(
    D,
    {
      isAuthenticated: t,
      openAuthModal: r,
      userImage: n,
      logout: i,
      hasNotifications: s,
      language: e,
      getTranslation: a,
      isLawyerSupported: u,
      useWill: m,
      lmpEnabled: l,
      onRequestLawyer: L ? c : void 0,
      hideLinks: p,
      environment: d,
      lawyerView: A,
      legalHubSupported: E,
      newChatUrl: N
    }
  ) });
};
export {
  k as FLOATING_CONTAINER_ID,
  R as MENU_HEADER_ID,
  q as MenuComponent
};
